import { Trans } from "@lingui/macro";
import {
  UiBox,
  UiDivider,
  UiLink,
  UiModuleLoader,
  UiTypography,
} from "@smp/ui";
import {
  IconPaint,
  IconPalette,
  IconPencil,
  IconPlus,
  IconStack,
  IconStar,
  IconTexture,
  IconTriangleSquareCircle,
  IconTypography,
} from "@tabler/icons-react";
import { useMemo } from "react";

import { HelperAdapterLink } from "@/components/helpers/helper_adapter_link";
import { useQueryPolotnoStickers } from "@/queries";
import { useContextStickers } from "@/screens/app_public/stickers/context";
import { customGeneratePath } from "@/utils";

import classes from "./nothing_found.module.css";

export const NothingFound = () => {
  const {
    pathPattern,
    state: { selectedTags },
  } = useContextStickers();

  const { data: stickersData, isLoading: isStickersLoading } =
    useQueryPolotnoStickers({
      tags__slug__in: selectedTags,
      page_size: 100,
    });

  const stickers = useMemo(
    () => stickersData?.pages.flatMap(({ results }) => results),
    [stickersData?.pages],
  );

  if (isStickersLoading) {
    return <UiModuleLoader />;
  }

  return (
    <>
      <UiBox className={classes.wrapper}>
        <UiBox>
          <UiBox
            justifyContent="space-evenly"
            className={classes.wrapper__icons}
          >
            <IconTypography />
            <IconStack />
            <IconStar />
            <IconPalette />
          </UiBox>
          <UiTypography className={classes.text}>
            <Trans>
              We don't have sticker that fits your request yet, but you can pick
              up something similar.
            </Trans>
          </UiTypography>
          <UiBox
            justifyContent="space-around"
            className={classes.wrapper__icons}
          >
            <IconTexture />
            <IconTriangleSquareCircle />
            <IconPlus />
            <IconPaint />
            <IconPencil />
          </UiBox>
        </UiBox>
      </UiBox>
      <UiBox p={4}>
        <UiDivider />
      </UiBox>

      <div className={classes.grid}>
        {stickers?.map((sticker) => (
          <UiLink
            component={HelperAdapterLink}
            key={sticker.id}
            className={classes.grid__item}
            to={customGeneratePath(pathPattern, { stickerId: sticker.id })}
          >
            <img
              className={classes.grid__item__img}
              loading="lazy"
              alt={String(sticker.id)}
              src={sticker.image_preview_url}
            />
          </UiLink>
        ))}
      </div>
    </>
  );
};
